import { useEffect, useState } from 'react';

// Components
import { Space } from 'antd';
import { Slider } from '../../../Slider';
import { Tooltip } from '../../../Tooltip';
import { VolumeIcon, VolumeMuteIcon, VolumeOneIcon, VolumeTwoIcon } from '../../../Icons';

// I18n
import { useTranslation } from 'react-i18next';
import { usePlayback } from '../../../../contexts/PlaybackContext';

const getIcon = (volume: number) => {
  if (volume === 0) {
    return <VolumeMuteIcon />;
  }

  if (volume < 0.4) {
    return <VolumeOneIcon />;
  }

  if (volume < 0.7) {
    return <VolumeTwoIcon />;
  }

  return <VolumeIcon />;
};

export const VolumeControls = () => {
  const { t } = useTranslation(['playingBar']);
  const { volumePercent, setVolumePercent, toggleMute } = usePlayback();
  const [volume, setVolume] = useState<number>(1);
  const [isAdjusting, setAdjusting] = useState(false);

  useEffect(() => {
    if (typeof volumePercent === 'number' && !isAdjusting) {
      setVolume(volumePercent / 100);
    }
    if (volumePercent == null && !isAdjusting) {
      setVolume(1);
    }
  }, [volumePercent, isAdjusting]);

  const muted = volume === 0;

  return (
    <div className='volume-control-container'>
      <Space style={{ display: 'flex' }}>
        <Tooltip title={muted ? t('Unmute') : t('Mute')}>
          <div
            onClick={() => {
              console.info('[MultiTab] volume-ui:toggle-mute', {
                muted,
                volumePercent: volumePercent ?? null,
              });
              toggleMute().catch(() => {});
            }}
          >
            {getIcon(muted ? 0 : volume)}
          </div>
        </Tooltip>

        <div className='flex items-center justify-between w-full' style={{ width: 90 }}>
          <Slider
            isEnabled
            value={muted ? 0 : volume}
            onChange={(value) => {
              setAdjusting(true);
              setVolume(value);
            }}
            onChangeEnd={(value) => {
              setAdjusting(false);
              setVolume(value ?? 0);
              console.info('[MultiTab] volume-ui:set', {
                value,
                volumePercent: volumePercent ?? null,
              });
              if (typeof value !== 'number' || !Number.isFinite(value)) {
                console.info('[MultiTab] volume-ui:skip-invalid', { value });
                return;
              }
              setVolumePercent(Math.round(value * 100), { userInitiated: true, source: 'ui-slider' }).catch(() => {});
            }}
          />
        </div>
      </Space>
    </div>
  );
};

export default VolumeControls;
